module.exports = __webpack_public_path__ + "assets/4f27380e12236873484117851ef90952.png";